var throttle = function throttle(fn) {
  var running = false;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (running) {
      return;
    }

    running = true;
    window.requestAnimationFrame(function () {
      fn.apply(void 0, args);
      running = false;
    });
  };
};

export default throttle;